import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-ag-radar-area-series-options',
	templateUrl:'./AgRadarAreaSeriesPluginCompPage.html',
	styles: [],
	styleUrls:['./AgRadarAreaSeriesPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class AgRadarAreaSeriesPluginCompPage
{
	mdContent_748 = `\`\`\`java
import com.jwebmp.plugins.agchartsenterprise.options.series.AgRadarAreaSeriesOptions;
\`\`\``;
}
